import React from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu/Menu';
import MyHead from '../../components/MyHead';

const PaymentsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <MyHead />
      <div>
        <Menu />
        <div
          className="h-500 flex justify-center items-end py-3"
          style={{
            background: `linear-gradient(to bottom, rgba(0, 20, 26, 0.1), rgba(0, 20, 26, 0.25)), url("../../img/general-page-img.jpg")`
          }}
        >
          <h1 className="text-8xl sm:text-9xl text-white uppercase mb-6">
            {t('PAYMENTS')}
          </h1>
        </div>
        <div className="flex items-stretch flex-col py-20 max-w-4xl mx-auto px-4 sm:px-0">
          <p className="font-bold mb-2">{t('PAYMENT_METHOD_TITLE')}</p>
          <div className="mb-10">
            <p className="mb-5">{t('PAYMENT_METHOD_INTRO')}</p>
            <ul className="list-disc list-inside">
              <li>{t('PAYMENT_METHOD_1')}</li>
              <li>{t('PAYMENT_METHOD_2')}</li>
            </ul>
          </div>

          <p className="font-bold mb-2">{t('PRICES_TITLE')}</p>
          <p>{t('PRICES_TEXT')}</p>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default PaymentsPage;
